import React from "react";
import {
  VegaFlex,
  VegaIcon,
  VegaFont,
  VegaBox,
} from "@heartlandone/vega-react";

function ActivityGuest({ isAllowInviteGuests }) {
  return (
    isAllowInviteGuests && <VegaFlex gap={"size-12"}>
      <VegaBox width="size-16" height="size-16">
        <VegaIcon
          icon="fal fa-user-plus"
          size="size-16"
          color="text-secondary"
        ></VegaIcon>
      </VegaBox>
      <VegaFont color="text-secondary" variant="font-field-value-sm">
        Guests Allowed
      </VegaFont>
    </VegaFlex>
  );
}

export default ActivityGuest;
